module.exports = __webpack_public_path__ + "static/media/SELECTstage3.4c2e4df0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layers/SELECTstage3.png
// module id = 169
// module chunks = 0